<template>
  <!-- For inline display within existing v-lists (Valuation.vue) -->
  <div v-if="inline">
    <v-list-item class="px-0">
      <v-list-item-title>{{ $t('labels.utm-source') }}:</v-list-item-title>
      <div class="text-grey text--darken-3 text-body-2">
        {{ utmSource || $t('labels.none') }}
      </div>
    </v-list-item>

    <v-list-item
      v-if="utmMedium"
      class="px-0"
    >
      <v-list-item-title>{{ $t('labels.utm-medium') }}:</v-list-item-title>
      <div class="text-grey text--darken-3 text-body-2">{{ utmMedium }}</div>
    </v-list-item>

    <v-list-item
      v-if="utmCampaign"
      class="px-0"
    >
      <v-list-item-title>{{ $t('labels.utm-campaign') }}:</v-list-item-title>
      <div class="text-grey text--darken-3 text-body-2">{{ utmCampaign }}</div>
    </v-list-item>

    <v-list-item
      v-if="utmContent"
      class="px-0"
    >
      <v-list-item-title>{{ $t('labels.utm-content') }}:</v-list-item-title>
      <div class="text-grey text--darken-3 text-body-2">{{ utmContent }}</div>
    </v-list-item>

    <v-list-item
      v-if="utmTerm"
      class="px-0"
    >
      <v-list-item-title>{{ $t('labels.utm-term') }}:</v-list-item-title>
      <div class="text-grey text--darken-3 text-body-2">{{ utmTerm }}</div>
    </v-list-item>
  </div>

  <!-- For grid layout with columns (ReturnCall.vue) -->
  <v-row v-else-if="hasUtmParams">
    <v-col
      cols="12"
      md="6"
      class="py-0"
    >
      <v-list density="compact">
        <v-list-item class="px-0">
          <v-list-item-title>{{ $t('labels.utm-source') }}:</v-list-item-title>
          <div class="text-grey text--darken-3 text-body-2">
            {{ utmSource || $t('labels.none') }}
          </div>
        </v-list-item>
      </v-list>
    </v-col>

    <v-col
      v-if="utmMedium"
      cols="12"
      md="6"
      class="py-0"
    >
      <v-list density="compact">
        <v-list-item class="px-0">
          <v-list-item-title>{{ $t('labels.utm-medium') }}:</v-list-item-title>
          <div class="text-grey text--darken-3 text-body-2">
            {{ utmMedium }}
          </div>
        </v-list-item>
      </v-list>
    </v-col>

    <v-col
      v-if="utmCampaign"
      cols="12"
      md="6"
      class="py-0"
    >
      <v-list density="compact">
        <v-list-item class="px-0">
          <v-list-item-title>{{ $t('labels.utm-campaign') }}:</v-list-item-title>
          <div class="text-grey text--darken-3 text-body-2">
            {{ utmCampaign }}
          </div>
        </v-list-item>
      </v-list>
    </v-col>

    <v-col
      v-if="utmContent"
      cols="12"
      md="6"
      class="py-0"
    >
      <v-list density="compact">
        <v-list-item class="px-0">
          <v-list-item-title>{{ $t('labels.utm-content') }}:</v-list-item-title>
          <div class="text-grey text--darken-3 text-body-2">
            {{ utmContent }}
          </div>
        </v-list-item>
      </v-list>
    </v-col>

    <v-col
      v-if="utmTerm"
      cols="12"
      md="6"
      class="py-0"
    >
      <v-list density="compact">
        <v-list-item class="px-0">
          <v-list-item-title>{{ $t('labels.utm-term') }}:</v-list-item-title>
          <div class="text-grey text--darken-3 text-body-2">
            {{ utmTerm }}
          </div>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

type Props = {
  utmParams: {
    source?: string
    medium?: string
    campaign?: string
    content?: string
    term?: string
  } | null
  inline?: boolean
}

const props = defineProps<Props>()

const hasUtmParams = computed(() => !!props.utmParams)
const utmSource = computed(() => props.utmParams?.source || '')
const utmMedium = computed(() => props.utmParams?.medium || '')
const utmCampaign = computed(() => props.utmParams?.campaign || '')
const utmContent = computed(() => props.utmParams?.content || '')
const utmTerm = computed(() => props.utmParams?.term || '')
</script>
